import React from "react";
import {css} from "@emotion/react";

import {Popover} from "@pg-design/notifications";

import {IQuartileBarProps, QuartileBar} from "../QuartileBar";

interface IDesktopQuartileBarProps extends IQuartileBarProps {
    children: React.ReactNode;
}

export const DesktopQuartileBar: React.FC<IDesktopQuartileBarProps> = (props) => (
    <Popover
        inline
        body={
            <QuartileBar
                avgPrice={props.avgPrice}
                firstQuartile={props.firstQuartile}
                secondQuartile={props.secondQuartile}
                thirdQuartile={props.thirdQuartile}
            />
        }
        isActive
        toggleClickHandler
        toggleOnClickOutside
        popoverPlace="bottom"
        arrow={false}
        bodyStyle={popover}
    >
        {props.children}
    </Popover>
);

const popover = css`
    min-width: 45rem;
    padding: 3.3rem 3.1rem;
    background: #fff !important;
`;
import React from "react";
import {css} from "@emotion/react";

import {Popover} from "@pg-design/notifications";

import {IQuartileBarProps, QuartileBar} from "../QuartileBar";

interface IDesktopQuartileBarProps extends IQuartileBarProps {
    children: React.ReactNode;
}

export const DesktopQuartileBar: React.FC<IDesktopQuartileBarProps> = (props) => (
    <Popover
        inline
        body={
            <QuartileBar
                avgPrice={props.avgPrice}
                firstQuartile={props.firstQuartile}
                secondQuartile={props.secondQuartile}
                thirdQuartile={props.thirdQuartile}
            />
        }
        isActive
        toggleClickHandler
        toggleOnClickOutside
        popoverPlace="bottom"
        arrow={false}
        bodyStyle={popover}
    >
        {props.children}
    </Popover>
);

const popover = css`
    min-width: 45rem;
    padding: 3.3rem 3.1rem;
    background: #fff !important;
`;
